<div class="news">
  <app-page-header
    searchPlaceholder="Search by title..."
    (searchEvent)="handleSearch($event)"
    pageTitle="News"
  >
    <button class="button" [routerLink]="['/add-news']" addButton>
      <img src="assets/images/add.svg" alt="+" />
      Add <span>News</span>
    </button></app-page-header
  >

  <ng-container *ngIf="deleteNewsId">
    <app-confirmation-modal
      primaryButtonText="Cancel"
      secondaryButtonText="Yes"
      message="Are you sure you want to delete this News ?"
      caption="Delete Confirmation"
      (onPrimaryButtonClick)="cancelDelete()"
      (onSecondaryButtonClick)="deleteNews()"
      [secondaryButtonLoading]="deleteLoading"
    ></app-confirmation-modal>
  </ng-container>

  <ng-container *ngIf="newsListLoading; else news">
    <div class="news__list flex-wrap">
      <div class="news__item" *ngFor="let i of [].constructor(6)">
        <div class="news__card">
          <app-skeleton [ratio]="1 / 1" margin="0 0 10px"></app-skeleton>
          <app-skeleton
            height="15px"
            width="80%"
            margin="0 0 3px"
          ></app-skeleton>
          <app-skeleton height="10px" width="90%"></app-skeleton>
          <app-skeleton
            height="10px"
            width="70%"
            margin="0 0 8px"
          ></app-skeleton>
          <div>
            <app-skeleton height="10px" width="100px"></app-skeleton>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #news>
    <ng-container *ngIf="newsList.length > 0; else noDataFound"></ng-container>
    <div class="news__list flex-wrap">
      <div class="news__item flex" *ngFor="let news of newsList; let i = index">
        <app-news-card
          [title]="news.title"
          [date]="news.date"
          [imageUrl]="news.img"
          [id]="news.id"
          [index]="i"
          [lastElement]="newsList.length === i + 1"
          [menuOpenIndex]="menuOpenIndex"
          (closeMenuEmitter)="closeAllMenu(i)"
          (openMenuEmitter)="openMenu(i)"
          (onDeleteNewsEmitter)="onDeleteNews($event)"
          (loadMoreIfLastIndexEmitter)="loadMoreIfLastIndex()"
        ></app-news-card>
      </div>
    </div>
    <div *ngIf="newsListLoading">
      <div class="news__list flex-wrap">
        <div class="news__item" *ngFor="let i of [].constructor(6)">
          <div class="news__card">
            <app-skeleton [ratio]="1 / 1" margin="0 0 10px"></app-skeleton>
            <app-skeleton
              height="15px"
              width="80%"
              margin="0 0 3px"
            ></app-skeleton>
            <app-skeleton height="10px" width="90%"></app-skeleton>
            <app-skeleton
              height="10px"
              width="70%"
              margin="0 0 8px"
            ></app-skeleton>
            <div>
              <app-skeleton height="10px" width="100px"></app-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #noDataFound>
    <div class="news__nodata">
      <p>No data found</p>
    </div>
  </ng-template>
</div>
